import { useState } from 'react';
import { Pressable, View } from 'react-native';

import { PasswordStrengthMeter } from './PasswordStrengthMeter';
import { Text } from './Text';
import { TextField, type TextFieldProps } from './TextField';

export interface PasswordFieldProps extends TextFieldProps {
  /** Show the strength meter below the field. */
  showStrength?: boolean;
}

export function PasswordField({ showStrength, value, ...props }: PasswordFieldProps) {
  const [show, setShow] = useState(false);
  return (
    <View className="gap-1.5">
      <TextField
        value={value}
        secureTextEntry={!show}
        autoCapitalize="none"
        autoCorrect={false}
        right={
          <Pressable onPress={() => setShow((s) => !s)} hitSlop={8}>
            <Text variant="caption" className="text-muted">
              {show ? 'Hide' : 'Show'}
            </Text>
          </Pressable>
        }
        {...props}
      />
      {showStrength ? (
        <PasswordStrengthMeter value={typeof value === 'string' ? value : ''} />
      ) : null}
    </View>
  );
}
